// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"125":"component---src-pages-404-js","170":"component---src-pages-politique-de-confidentialite-js","293":"component---src-pages-index-js","496":"component---src-pages-mentions-legales-js"}[chunkId] || chunkId) + ".js";
};